import { BrowserRouter } from "react-router-dom";
import ThemeRoutes from "./routes";

const App = () => {
  return (
    <BrowserRouter>
      <ThemeRoutes />
    </BrowserRouter>
  );
};

export default App;
